let started = false;

const specialistGraphObserver: IntersectionObserver = new IntersectionObserver( ( entries ) => {
	for ( const entry of entries ) {
		if ( !entry.target || !( entry.target instanceof HTMLElement ) ) {
			return;
		}

		if ( entry.isIntersecting ) {
			if ( started ) {
				return;
			}

			started = true;

			entry.target.setAttribute( 'is-animating', '' );

			const graphItems = entry.target.querySelectorAll( 'div[specialist-graph-item]' ) as NodeListOf<HTMLElement>;

			if ( !graphItems ) {
				return;
			}

			let i = 0;
			graphItems.forEach( ( item ) => {
				setTimeout( () => {
					const bar = item.querySelector( 'span[specialist-graph-bar]' ) as HTMLElement;
					bar.style.transform = 'scaleX(1)';
				}, 288 * i );
				i++;
			} );
		}
	}
}, {
	threshold: 0.9,
} );

function initSpecialistGraphObserver() {
	if ( !( 'IntersectionObserver' in self ) ) {
		return;
	}

	const observed = document.querySelector( 'div[specialist-graph]' );
	if ( !observed ) {
		return;
	}

	specialistGraphObserver.observe( observed );
}

initSpecialistGraphObserver();
requestAnimationFrame( () => {
	initSpecialistGraphObserver();
} );

window.addEventListener( 'load', () => {
	initSpecialistGraphObserver();
} );
